import Subject from "../models/Subject";
export default class SubjectService {
    mapInterfaceToModel(input, repositories = null) {
        let subject = new Subject();
        subject.id = parseInt(input.id);
        subject.code = input.code;
        subject.name = input.name;
        return subject;
    }
}
